import { useEffect, useRef, useState } from "react";
import useSound from "use-sound";
import useSoundStore from "../../stores/useSoundStore";

export interface UseCityHallConfettiResult {
  playVoteSuccess: () => void;
  showConfetti: boolean;
  triggerConfetti: () => void;
}

export function useCityHallConfetti(): UseCityHallConfettiResult {
  const { soundsEnabled } = useSoundStore();
  const [playConfetti] = useSound('/game-assets/sounds/confetti.mp3', { volume: 0.12, soundEnabled: soundsEnabled });
  const [playVoteSuccess] = useSound('/game-assets/sounds/bubble-tap.mp3', { volume: 0.08, soundEnabled: soundsEnabled });
  const confettiSoundPlayedRef = useRef(false);
  const [showConfetti, setShowConfetti] = useState(false);

  const triggerConfetti = () => {
    confettiSoundPlayedRef.current = false;
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 4000);
  };

  useEffect(() => {
    if (showConfetti && !confettiSoundPlayedRef.current) {
      playConfetti();
      confettiSoundPlayedRef.current = true;
    }
    if (!showConfetti) confettiSoundPlayedRef.current = false;
  }, [showConfetti, playConfetti]);

  return {
    playVoteSuccess,
    showConfetti,
    triggerConfetti,
  };
}
